import { createMuiTheme } from '@material-ui/core/styles';

const defaultFontFamily =
  'Noto Sans KR,-apple-system,BlinkMacSystemFont,Roboto,Helvetica,sans-serif';

// Create a theme instance.
export default createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: 720,
      lg: 1120,
      xl: 1280,
    },
  },
  typography: {
    fontFamily: defaultFontFamily,
    fontSize: 16,
    h1: {
      fontSize: '6rem',
      fontWeight: 700,
      lineHeight: 'normal',
    },
    h2: {
      fontSize: '3.75rem',
      fontWeight: 700,
      lineHeight: 'normal',
    },
    h3: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 'normal',
    },
    h4: {
      fontSize: '2.125rem',
      fontWeight: 700,
      lineHeight: 'normal',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 'normal',
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: 'normal',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 'normal',
    },
    body2: {
      fontSize: '.875rem',
      fontWeight: 500,
      lineHeight: 'normal',
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 'normal',
    },
    subtitle2: {
      fontSize: '.875rem',
      fontWeight: 500,
      lineHeight: 'normal',
    },
    button: {
      fontSize: '.875rem',
    },
    caption: {
      fontSize: '.75rem',
      fontWeight: 500,
      lineHeight: 'normal',
    },
    overline: {
      fontSize: '.625rem',
      lineHeight: 'normal',
      letterSpacing: 'normal',
    },
  },
  palette: {
    primary: {
      main: '#26A69A',
      light: '#ddebf9',
      dark: '#212658',
    },
    secondary: {
      main: '#286594',
      dark: '#31387F',
    },
  },
  overrides: {
    MuiInputBase: {
      input: {
        fontFamily: defaultFontFamily,
        '&.Mui-disabled': {
          backgroundColor: '#e9ecef',
        },
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: 0,
        },
      },
    },
    MuiButton: {
      root: {
        padding: '6px 8px',
        borderRadius: 0,
      },
      outlined: {
        padding: '6px 8px',
      },
    },
    MuiTypography: {
      button: {
        fontWeight: 700,
      },
    },
    MuiTableRow: {
      head: {
        '& > th': {
          fontWeight: 700,
          fontSize: 16,
        },
      },
    },
  },
});
